import amapi from 'Api/amapi'

const initialState = () => ({
  promo: {},
  promoPopulated: false,
  promoServices: [], // eligible service IDs
  promoServicesPopulated: false,
  promoRequest: null,
  promotions: []
})

const state = initialState

const getters = {
  promo: state => state.promo,
  promoPopulated: state => state.promoPopulated,
  promoServices: state => state.promoServices,
  promoServicesPopulated: state => state.promoServicesPopulated,
  promotions: state => state.promotions
}

const mutations = {
  SET_PROMO: (state, promo) => {
    state.promo = promo
    state.promoPopulated = true
  },
  SET_PROMO_SERVICES: (state, servicesId) => {
    state.promoServices = servicesId
    state.promoServicesPopulated = true
  },
  SET_PROMOTIONS_LIST: (state, data) => {
    state.promotions = data
  },
}

const actions = {
  async getPromo ({ commit }, promo_id) {
    try {
      const data = { promo_id }

      const response = await amapi.makecall('promo_details', data)
      const promo = {
        id: promo_id,
        name: response.promo_name,
        type: response.promo_type,
        description: response.promo_description,
        active: response.promo_active,
      }
      commit('SET_PROMO', promo)
    } catch (err) {
      throw err
    }
  },
  async checkPromo ({ commit }, promo_id) {
    try {
      const data = { promo_id }
      const response = await amapi.makecall('promo_check', data)
      commit('SET_PROMO_SERVICES', response.eligible_services)
    } catch (err) {
      throw err
    }
  },
  async submitPromo ({ commit }, data) {
    try {
      return amapi.makecall('promo_submit', data)
    } catch (err) {
      throw err
    }
  },
  async getPromoList ({ commit }) {
    try {
      const response = await amapi.makecall('promo_list')

      commit('SET_PROMOTIONS_LIST', response.promo_list)
      return response
    } catch (err) {
      throw err
    }
  },
  async getPromoView ({ commit }, request_id) {
    try {
      return amapi.makecall('promo_view', request_id)
    } catch (err) {
      throw err
    }
  },
  async getPromoStatus ({ commit }, request_id) {
    try {
      return amapi.makecall('promo_status', request_id)
    } catch (err) {
      throw err
    }
  },
}

export default {
  state,
  getters,
  mutations,
  actions
}
